import * as React from 'react'

const RefundPolicy = () => {
    return (
        <div id="content">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h3 className="text-muted">Definitions and key terms</h3>
                  <p className="text-muted">
                    To help explain things as clearly as possible in this Return
                    &amp; Refund Policy, every time any of these terms are
                    referenced, are strictly defined as:
                  </p>

                  <ul className="text-muted">
                    <li>
                      Company: when this policy mentions “Company,” “we,” “us,”
                      or “our,” it refers to Advocacy.biz by Capitol Enquiry,
                      that is responsible for your information under this Return
                      &amp; Refund Policy.
                    </li>
                    <li>
                      Customer: refers to the company, organization or person
                      that signs up to use the Advocacy.biz by Capitol Enquiry
                      Service to manage the relationships with your consumers or
                      service users.
                    </li>
                    <li>
                      Device: any internet connected device such as a phone,
                      tablet, computer or any other device that can be used to
                      visit Advocacy.biz by Capitol Enquiry and use the
                      services.
                    </li>
                    <li>
                      Service: refers to the service provided by Advocacy.biz by
                      Capitol Enquiry as described in the relative terms (if
                      available) and on this platform.
                    </li>
                    <li>
                      Website: Advocacy.biz by Capitol Enquiry’s site, which can
                      be accessed via this URL: https://www.advocacy.biz
                    </li>
                    <li>
                      You: a person or entity that is registered with
                      Advocacy.biz by Capitol Enquiry to use the Services.
                    </li>
                  </ul>
                  <h3 className="text-muted"></h3>
                  <h3 className="text-muted">Return &amp; Refund Policy</h3>
                  <p className="text-muted">
                    Thanks for shopping at Advocacy.biz by Capitol Enquiry. We
                    appreciate the fact that you like to buy the stuff we build.
                    We also want to make sure you have a rewarding experience
                    while you’re exploring, evaluating, and purchasing our
                    products.
                  </p>
                  <p className="text-muted">
                    As with any shopping experience, there are terms and
                    conditions that apply to transactions at Advocacy.biz by
                    Capitol Enquiry. We’ll be as brief as our attorneys will
                    allow. The main thing to remember is that by placing an
                    order or making a purchase at Advocacy.biz by Capitol
                    Enquiry, you agree to the terms set forth below along with
                    Advocacy.biz by Capitol Enquiry’s Privacy Policy.
                  </p>
                  <p className="text-muted">
                    If there’s something wrong with the product/service you
                    bought, or if you are not happy with it, you have 1 month to
                    issue a refund and return your product/service.
                  </p>
                  <p className="text-muted">
                    If you would like to return a product, the only way would be
                    if you follow the next guidelines:
                  </p>

                  <ul className="text-muted">
                    <li>
                      The product has to be in the packaging we sent in the
                      first place.
                    </li>
                  </ul>
                  <h3 className="text-muted"></h3>
                  <h3 className="text-muted">Refunds</h3>
                  <p className="text-muted">
                    We at Advocacy.biz by Capitol Enquiry, commit ourselves to
                    serve our customers with the best products. Every single
                    product that you choose is thoroughly inspected, checked for
                    defects and packaged with utmost care. We do this to ensure
                    that you fall in love with our products.
                  </p>
                  <p className="text-muted">
                    Sadly, there are times when we may not have the product(s)
                    that you choose in stock, or may face some issues with our
                    inventory and quality check. In such cases, we may have to
                    cancel your order. You will be intimated about it in advance
                    so that you don't have to worry unnecessarily about your
                    order. If you have purchased via Online payment (not Cash on
                    Delivery), then you will be refunded once our team confirms
                    your request.
                  </p>
                  <p className="text-muted">
                    We carry out thorough quality check before processing the
                    ordered item. We take utmost care while packing the product.
                    At the same time we ensure that the packing is good such
                    that the items won’t get damaged during transit. Please note
                    that Advocacy.biz by Capitol Enquiry is not liable for
                    damages that are caused to the items during transit or
                    transportation.
                  </p>
                  <p className="text-muted">
                    We will revise your returned product as soon as we receive
                    it and if it follows the guidelines addressed above, we will
                    proceed to issue a refund of your purchase. Your refund may
                    take a couple of days to process but you will be notified
                    when you receive your money.
                  </p>

                  <h3 className="text-muted"></h3>
                  <h3 className="text-muted">Shipping</h3>
                  <p className="text-muted">
                    Advocacy.biz by Capitol Enquiry is not responsible for
                    return shipping costs. Every shipping has to be paid by the
                    customer, even if the item had free shipping in the first
                    place, the customer has to pay for the shipping in return.
                  </p>

                  <h3 className="text-muted"></h3>
                  <h3 className="text-muted">Your Consent</h3>
                  <p className="text-muted">
                    By using our website, registering an account, or making a
                    purchase, you hereby consent to our Return &amp; Refund
                    Policy and agree to its terms.
                  </p>

                  <h3 className="text-muted"></h3>
                  <h3 className="text-muted">
                    Changes To Our Return &amp; Refund Policy
                  </h3>
                  <p className="text-muted">
                    Should we update, amend or make any changes to this document
                    so that they accurately reflect our Service and policies.
                    Unless otherwise required by law, those changes will be
                    prominently posted here. Then, if you continue to use the
                    Service, you will be bound by the updated Return &amp;
                    Refund Policy. If you do not want to agree to this or any
                    updated Return &amp; Refund Policy, you can delete your
                    account.
                  </p>

                  <h3 className="text-muted"></h3>
                  <h3 className="text-muted">Contact Us</h3>
                  <p className="text-muted">
                    If, for any reason, You are not completely satisfied with
                    any good or service that we provide, don't hesitate to
                    contact us and we will discuss any of the issues you are
                    going through with our product.
                  </p>

                  <ul className="text-muted">
                    <li>Via Email: info@advocacy.biz</li>
                    <li>Via Phone Number: 9163020000</li>
                    <li>
                      Via this Address: 1034 Emerald Bay Rd #435, South Lake
                      Tahoe, CA 96150
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
    )
}

export default RefundPolicy
